export default __webpack_public_path__ + "static/media/01-selfie.dce85700.jpg";